import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { FormatQualifier } from "../../qualifiers/format/FormatQualifier.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { DELIVERY_MODE_TO_ACTION_TYPE_MAP } from "../../internal/internalConstants.js";
/**
 * @description Qualifies the delivery of an asset.
 * @memberOf Actions.Delivery
 * @extends SDK.Action
 */

var DeliveryAction = /*#__PURE__*/function (_Action) {
  _inherits(DeliveryAction, _Action);

  var _super = _createSuper(DeliveryAction);

  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  function DeliveryAction(deliveryKey, deliveryType, modelProperty) {
    var _this;

    _classCallCheck(this, DeliveryAction);

    _this = _super.call(this);
    _this._actionModel = {};
    var deliveryTypeValue;

    if (deliveryType instanceof FormatQualifier) {
      deliveryTypeValue = deliveryType.getValue();
    } else {
      deliveryTypeValue = deliveryType;
    }

    _this._actionModel.actionType = DELIVERY_MODE_TO_ACTION_TYPE_MAP[deliveryKey];
    _this._actionModel[modelProperty] = deliveryTypeValue;

    _this.addQualifier(new Qualifier(deliveryKey, deliveryType));

    return _this;
  }

  return DeliveryAction;
}(Action);

export { DeliveryAction };